<section [title]="title()">
  <div detail>
    <div fieldset>
      <div field>
        <span label>Customer Number</span>
        <span value>{{ savedPartList()?.customerNumber }}</span>
      </div>
      <div field>
        <span label>Updated On</span>
        <span value>{{ savedPartList()?.updatedOn | date: "medium" }}</span>
      </div>
      <div field>
        <span label>Created On</span>
        <span value>{{ savedPartList()?.createdOn | date: "medium" }}</span>
      </div>
    </div>
    <div actions>
      <!-- <ideal-cart-stepper-input [control]="control" label="Multiple" [(quantity)]="multiple"></ideal-cart-stepper-input>
      <button mat-flat-button (click)="addToCart()">
        <mat-icon>add_shopping_cart</mat-icon>
        <span>Add to Cart</span>
      </button> -->
    </div>
  </div>
</section>

<ideal-saved-part-list-results></ideal-saved-part-list-results>
